import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  Typography,
} from "@mui/material";
import { useState } from "react";
import useColors from "../api/hooks/useColors";
import SvgToIcon from "../icons/SvgToIcon";
import {
  logos,
  severities,
} from "../scenes/stack/environment/icons/iconExport";
import { SeeMoreContent } from "./SeeMoreContent";

export default function GapSummaryCard({ summary, risk, background }) {
  const colors = useColors();
  const [isExpanded, setIsExpanded] = useState(false);

  const handleAccordionChange = (event, newExpandedState) => {
    setIsExpanded(newExpandedState);
  };

  const handleTextInteraction = (event) => {
    // Prevent accordion toggle when interacting with text
    event.stopPropagation();
  };

  // Character limits
  const oneLineCharLimit = 100;
  const sectionCharLimit = 160;

  return (
    <Accordion
      disableGutters
      elevation={0}
      expanded={isExpanded}
      onChange={handleAccordionChange}
      sx={{
        border: `1px solid ${colors.divider2}`,
        borderRadius: "8px",
        boxShadow: "none",
        "&:before": {
          display: "none",
        },
        "&.Mui-expanded": {
          margin: 0,
        },
        "&:last-of-type": {
          borderRadius: "8px",
        },
        "&:first-of-type": {
          borderRadius: "8px",
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="gap-summary-details-content"
        id="gap-summary-header"
        sx={{
          padding: "12px 16px",
          "& .MuiAccordionSummary-content": {
            margin: 0,
            display: "flex",
            alignItems: "flex-start",
          },
        }}
      >
        <SvgToIcon
          IconLogo={severities.SeverityBackgroundInfoIcon}
          width="24px"
          style={{
            color: colors.info_main,
            marginRight: "12px",
            marginTop: "3px",
          }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            textAlign: "left",
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{
              color: colors.text_primary,
            }}
          >
            Gap Summary
          </Typography>
          {!isExpanded ? (
            <Typography
              variant="body2"
              sx={{
                color: colors.text_primary,
                lineHeight: 1.4,
                marginTop: "4px",
                userSelect: "text",
                cursor: "text",
              }}
              onMouseDown={handleTextInteraction}
              onClick={handleTextInteraction}
            >
              {summary.substring(0, oneLineCharLimit)}...
            </Typography>
          ) : (
            <Typography
              variant="body2"
              sx={{
                color: colors.text_primary,
                lineHeight: 1.4,
                marginTop: "4px",
                userSelect: "text",
                cursor: "text",
              }}
              onMouseDown={handleTextInteraction}
              onClick={handleTextInteraction}
            >
              {summary}
            </Typography>
          )}
        </Box>
      </AccordionSummary>
      <AccordionDetails
        id="gap-summary-details-content"
        sx={{ padding: "0px 16px 16px 16px" }}
      >
        <Divider
          orientation="horizontal"
          flexItem
          style={{ margin: "6px 0" }}
        />

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            gap: "10px",
            marginBottom: "8px",
          }}
        >
          <SvgToIcon IconLogo={logos.BreezeLogo} style={{ width: "24px" }} />
          <Typography
            variant="subtitle1"
            sx={{
              color: colors.text_primary,
            }}
          >
            Breeze Insights
          </Typography>
        </Box>

        {risk && (
          <Box sx={{ marginBottom: "12px", paddingLeft: "36px" }}>
            <Typography
              variant="subtitle2"
              sx={{
                color: colors.primary_main,
                display: "block",
                marginBottom: "4px",
              }}
            >
              Risk
            </Typography>
            <SeeMoreContent
              content={risk}
              initialCharCount={sectionCharLimit}
              marginTop="0"
              fontSize={"14px"}
            />
          </Box>
        )}

        {background && (
          <Box sx={{ paddingLeft: "36px" }}>
            <Typography
              variant="subtitle2"
              sx={{
                color: colors.primary_main,
                display: "block",
                marginBottom: "4px",
              }}
            >
              Background
            </Typography>
            <SeeMoreContent
              content={background}
              initialCharCount={sectionCharLimit}
              marginTop="0"
              fontSize={"14px"}
            />
          </Box>
        )}
      </AccordionDetails>
    </Accordion>
  );
}
